import React from 'react';
import { Link } from 'react-router-dom';

function TrainingOverview() {
  return (
    <div className="container my-5">
      <h1 className="text-center mb-4">Training Overview</h1>
      <div className="text-center mb-5">
        <img
          src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=800&q=80"
          alt="Training Overview"
          className="img-fluid rounded"
          style={{ maxHeight: 300 }}
        />
        <p className="mt-3">
          Explore our hands-on training courses designed to boost your test automation skills.
        </p>
      </div>
      <div className="row">
        <div className="col-md-4 mb-4">
          <div className="card h-100">
            <img
              src="https://playwright.dev/img/playwright-logo.svg"
              className="card-img-top p-4"
              alt="Playwright Training"
              style={{ height: 150, objectFit: 'contain' }}
            />
            <div className="card-body d-flex flex-column">
              <h5 className="card-title">Playwright with TypeScript</h5>
              <p className="card-text">
                Learn end-to-end UI automation using Playwright and TypeScript.
              </p>
              <Link to="/tr/playwright" className="btn btn-info mt-auto">
                View Course
              </Link>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card h-100">
            <img
              src="https://rest-assured.io/img/logo-transparent.png"
              className="card-img-top p-4"
              alt="Rest Assured Training"
              style={{ height: 150, objectFit: 'contain' }}
            />
            <div className="card-body d-flex flex-column">
              <h5 className="card-title">Rest Assured with Java</h5>
              <p className="card-text">
                Master API automation with Rest Assured and Java.
              </p>
              <Link to="/tr/restassured" className="btn btn-info mt-auto">
                View Course
              </Link>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card h-100">
            <img
              src="https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png"
              className="card-img-top p-4"
              alt="GitHub Actions Training"
              style={{ height: 150, objectFit: 'contain' }}
            />
            <div className="card-body d-flex flex-column">
              <h5 className="card-title">GitHub Actions</h5>
              <p className="card-text">
                Automate your CI/CD pipelines with GitHub Actions.
              </p>
              <Link to="/tr/githubactions" className="btn btn-info mt-auto">
                View Course
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrainingOverview;
